import React, { Component } from 'react';
import { Segment, Header } from 'semantic-ui-react';

export default class ClassPolicies extends Component {
  render() {
    return (
      <Segment vertical>
        <Header as='h1' content="Class Policies" />
        <a name="virtual" />
        <Header as="h3" content="Virtual classes" />
        <p>
          There will be some weeks in which class will be virtual — they are marked on the calendar.  We will run class via BlueJeans on those days.

          I will share the BlueJeans invite link on MS Teams and Canvas. On virtual class days, I do not require you to turn your
          camera on during the lecture portion of the class. I strongly encourage you to do so during the discussion portion of the class, but 
          again do not require it. 
        </p>
        <a name="devices" />
        <Header as="h3" content="Devices in Class" />
        <p>
          Educational research and student feedback suggest that using devices on non-class related
          activities not only harms your own learning, but other students' learning as well. Accordingly,
          when we are meeting in-person, I <i>discourage the use of laptops or cellphones in class</i> unless
          it is for specific in-class activities.

          That said, if you believe it would truly help your learning, I may consider allowing your use of
          a laptop on a case-by-case basis. Send me an e-mail making your case.
        </p>
        <a name="attendance" />
        <Header as="h3" content="Attendance" />
          <p>
            We live in strange times. Class attendance is encouraged if you are feeling healthy and able,
            but not required. Attendance is encouraged because a big part of the value-add of this class
            is the discussions; without them, you lose a lot of color in your understanding of the content.

            If you need to miss class, that is fine. However, please do note that if you miss class then
            you are expected to write a paragraph or two for your reading commentary. If you attend, then
            you need only write three discussion prompts.
          </p>
        <a name="participation" />
        <Header as="h3" content="Participation" />
          <p>
            Participation means contributing to in-class discussions and activities.
            As long as you make a good faith attempt, you will score well.
          </p>

          <p>
            Your class participation grade will be out of 10. You start at an 8. If you are active in
            discussions, in-class activities and other activities that count towards your
            participation grade, your grade can improve to a 9 or 10. Of course, if you rarely or
            never participate, your grade will be lowered in turn.
          </p>
        <Header as="h3" content="Absence" />
        <p>
          Attendance is not required so you do not need my permission to take an absence. However, please
          note that I still expect reading commentaries for the readings covered in class that day. If you
          would like to be excused from writing the reading commentaries, then you should e-mail me and 
          make your case.
        </p>
        <Header as="h3" content="Late Submissions" />
        <p>
          Unless explicitly noted, most assignments may be submitted up to three days late. There will be a
          5 point penalty for each day an assignment is turned in late.
        </p>

        <p>
          Reading commentaries may not be submitted late. Clearly, it is also not possible to be late
          on leading a discussion or presenting your final presentations.
        </p>
        <Header as="h3" content="Honor Code" />
        <p>
          This class abides by the <a href="http://www.policylibrary.gatech.edu/student-affairs/academic-honor-code">
          Georgia Tech Honor Code</a>. All assigned work is expected to be individual, except for the
          group assignments related to the group project. You are encouraged to discuss the
          assignments with your classmates; however, what you hand in should be your own work.
        </p>
      </Segment>
    );
  }
}


// WEBPACK FOOTER //
// ./src/components/class-policies.js